import React from "react";

const IX = ({
  color = "#252526",
  width = "12",
  height = "12",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M2.5527 8.73988L8.73988 2.5527C8.93514 2.35743 9.25173 2.35743 9.44699 2.5527C9.64225 2.74796 9.64225 3.06454 9.44699 3.2598L3.2598 9.44699C3.06454 9.64225 2.74796 9.64225 2.5527 9.44699C2.35744 9.25173 2.35744 8.93514 2.5527 8.73988Z"
        fill={color}
      />
      <path
        d="M9.44699 8.73988C9.64225 8.93514 9.64225 9.25173 9.44699 9.44699C9.25173 9.64225 8.93514 9.64225 8.73988 9.44699L2.5527 3.2598C2.35743 3.06454 2.35743 2.74796 2.5527 2.5527C2.74796 2.35743 3.06454 2.35743 3.2598 2.5527L9.44699 8.73988Z"
        fill={color}
      />
    </svg>
  );
};

export default IX;
